import React, { type FC } from 'react'
import cn from 'classnames'

import { type BaseProps } from 'types'
import styles from './style.scss'

export interface Props extends BaseProps {
  className?: string
  iconClassName?: string
  isOverlay?: boolean
  height?: string
}

const Loader: FC<Props> = ({ className, isOverlay, height, iconClassName }) => {
  return (
    <div
      className={cn(styles['loader'], className, {
        [styles['--overlay']]: isOverlay,
      })}
      style={{ height }}
    >
      <span role='alert' aria-label='loader' className={cn(styles['icon-v2'], iconClassName)} />
    </div>
  )
}

export default Loader
